import './App.scss';
import {Route, Routes} from 'react-router-dom';
import React, {Suspense, useEffect, useState} from "react";
import Loader from "./Components/Commons/Loader";
import {routes} from "./routes";
import {service_routes} from "./routes";
import withUser from "./Containers/withUser";
import AppLayout from "./layouts/AppLayout";
import ProtectedRoute from "./Components/Commons/Nav/ProtectedRoute";
import {Share, EllipsisVertical} from 'lucide-react'
import classNames from "classnames";
import {getCookie, setCookie} from "./helpers/cookies";
import ServiceLayout from "./layouts/ServiceLayout";


let deferredPrompt;
const Root = (props) => {

    const {authorized} = props

    const [showOther, setShowOther] = useState(false)
    const [hideOther, setHideOther] = useState(false)

    const appRoutes = routes.map((route, i) => {
        return (route.component) ? (
                <Route
                    index={route.index}
                    path={!route.index ? route.path : '/'}
                    key={i}
                    element={
                        !route.index ? <ProtectedRoute authorized={authorized}>
                            <route.component {...props} />
                        </ProtectedRoute> : <route.component {...props} />
                    }
                />
            ) :
            null;
    });

    const serviceRoutes = service_routes.map((route, i) => {
        return (route.component) ? (
                <Route
                    index={route.index}
                    path={route.path}
                    key={i}
                    element={
                    <route.component {...props} />
                    }
                />
            ) :
            null;
    });

    const SafariModal = () => {
        return <div className={classNames({
            "other_modal": true,
            "hide": hideOther
        })}>
            <h2>Install Coldware Application for best experience</h2>
            <p>To install a PWA, click Share <Share className={'share_icon'}/> and select <span className={'bold_text'}>"Add to Home Screen"</span>
            </p>
            <div className={'cta_wrapper'}>
                <button
                    style={{width: '100%', display: "flex", justifyContent: 'center'}}
                    className={'buy_cta'}
                    onClick={() => {
                        setHideOther(true)
                        setTimeout(() => {
                            setShowOther(false)
                        }, 1000)
                    }}
                    id="closeBanner">Got it
                </button>
                <button
                    style={{width: '100%', display: "flex", justifyContent: 'center'}}
                    className={'buy_cta cancel'}
                    onClick={() => {
                        setCookie('dont_show_pwa', true, {expires: 60000 * 60 * 24 * 10})
                        setHideOther(true)
                        setTimeout(() => {
                            setShowOther(false)
                        }, 1000)
                    }}
                    id="closeBanner">Dont show again
                </button>
            </div>
        </div>
    }

    const OtherModal = () => {
        return <div className={classNames({
            "other_modal": true,
            "hide": hideOther
        })}>
            <h2>Install Coldware Application for best experience</h2>
            <p>To install a PWA, click More <EllipsisVertical className={'share_icon'}/> and select <span
                className={'bold_text'}>"Add to Home Screen"</span>
            </p>
            <div className={'cta_wrapper'}>
                <button
                    style={{width: '100%', display: "flex", justifyContent: 'center'}}
                    className={'buy_cta'}
                    onClick={() => {
                        setHideOther(true)
                        setTimeout(() => {
                            setShowOther(false)
                            deferredPrompt.prompt();
                            deferredPrompt.userChoice.then((choiceResult) => {
                                if (choiceResult.outcome === 'accepted') {
                                    console.log('PWA installed');
                                } else {
                                    console.log('User reject');
                                }
                                deferredPrompt = null;
                            });
                        }, 1000)
                    }}
                    id="closeBanner">Install
                </button>
                <button
                    style={{width: '100%', display: "flex", justifyContent: 'center'}}
                    className={'buy_cta cancel'}
                    onClick={() => {
                        setCookie('dont_show_pwa', true, {expires: 60000 * 60 * 24 * 10})
                        setHideOther(true)
                        setTimeout(() => {
                            setShowOther(false)
                        }, 1000)
                    }}
                    id="closeBanner">Dont show again
                </button>
            </div>
        </div>
    }

    function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    function isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }


    useEffect(() => {
        if (!getCookie('dont_show_pwa')) {
            if (isSafari() && !window.matchMedia('(display-mode: standalone)').matches) {
                setTimeout(() => {
                    setShowOther(true)
                }, 2000)
            } else {
                setTimeout(() => {
                    setShowOther(true)
                }, 2000)
                window.addEventListener('beforeinstallprompt', (event) => {
                    deferredPrompt = event;
                });
            }
        }
    }, []);

    return (
        <>
            <div className="app">
                <div className="app_wrapper">
                    <Routes>
                        <Route
                            path={'/'}
                            element={
                                <Suspense fallback={<Loader/>}>
                                    <AppLayout {...props}/>
                                </Suspense>
                            }
                        >
                            {appRoutes}
                        </Route>
                        <Route
                            path={'/'}
                            element={
                                <Suspense fallback={<Loader/>}>
                                    <ServiceLayout {...props}/>
                                </Suspense>
                            }
                        >
                            {serviceRoutes}
                        </Route>
                    </Routes>
                </div>
                {showOther && isSafari() && isMobile() && <SafariModal/>}
                {showOther && isMobile() && !isSafari() && <OtherModal/>}
            </div>
        </>
    );
}

export default withUser(Root);
